class CancelSubscriptions {
    constructor() {
        this.initCancelSubscription();
        this.showMichalCizekSection();
        this.cancelSubscriptionFormValidation();
    }
    initCancelSubscription(){
        const thisClass = this;
        const cancelSubscriptionBtns = document.querySelectorAll('.subscription-action .cancel-subscription');
        cancelSubscriptionBtns.forEach(c => {
            // Checkbox on click event
            c.addEventListener('click', function (e) {
                // Show loading indication
                c.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                c.disabled = true;
                let organizationID = e.currentTarget.getAttribute('data-value');
                if(organizationID){
                    naja.makeRequest('GET', '?do=getCancelSubscriptionInfo', {
                        'organizationID': organizationID
                    }, {
                        history: false // Prevent URL changes in browser history
                    }).then((response) => {
                        if(response){
                            let cancelSubscriptionModal = document.getElementById('cancel_subscription_modal');
                            thisClass.cancelSubscriptionFormValidation();
                            KTScroll.createInstances();
                            new bootstrap.Modal(cancelSubscriptionModal).show();
                            // Show loading indication
                            c.setAttribute('data-kt-indicator', 'off');
                            // Disable button to avoid multiple click
                            c.disabled = false;
                        }
                    });
                }
            });
        });
    }
    showMichalCizekSection(){
        $(document).on('change', '#cancel_subscription_modal input[name=CauseRadioList]', function() {
            $('#howWeCanImproveContainer').removeClass('d-none');
        });
    }
    cancelSubscriptionFormValidation(){
        let form = document.getElementById('frm-cancelSubscriptionForm-cancelSubscriptionForm');
        if(form){
            let submitButton = document.getElementById('cancel_subscription_form_submit');

            FormValidation.formValidation(
                form,
                {
                    fields: {
                        'CauseRadioList': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                        'password': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        message: new FormValidation.plugins.Message({
                            container: function (field, ele) {
                                return FormValidation.utils.closest(ele, '.fv-message-container').nextElementSibling;
                            },
                        }),
                    }
                }
            ).on('core.form.validating', function(event) {
                new DismissModal('cancel_subscription_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('cancel_subscription_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
}
window.CancelSubscriptions = CancelSubscriptions;